import { Landmark } from 'lucide-react';
import LegalDocument from '@/components/LegalDocument';

export default function AvisoLegal() {
  return <LegalDocument docKey="legal_doc" icon={Landmark} />;
}
